import { render, staticRenderFns } from "./AdminListInfo.vue?vue&type=template&id=0c191606"
import script from "./AdminListInfo.vue?vue&type=script&lang=js"
export * from "./AdminListInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports